// Static policy copy. Keyed by page, then language.
export const LEGAL = {
  terms: {
    ms: {
      title: "Terma Perkhidmatan",
      updated: "Jun 2026",
      description: "Terma Perkhidmatan penggunaan direktori perniagaan DirektoriBiz.my.",
      intro:
        "Terma Perkhidmatan ini mengawal penggunaan laman web dan perkhidmatan DirektoriBiz.my (“Perkhidmatan”) yang dikendalikan oleh YBD INFINITY GLOBAL (202603212324 / JM1048394-W) (“kami”). Dengan mengakses laman web ini atau mendaftarkan senaraian perniagaan, anda bersetuju untuk terikat dengan terma di bawah.",
      sections: [
        {
          heading: "1. Perkhidmatan yang disediakan",
          paragraphs: [
            "DirektoriBiz.my ialah platform direktori perniagaan tempatan yang memaparkan maklumat perniagaan di Malaysia. Kami menyediakan ruang penyenaraian, halaman khas perniagaan, serta pakej promosi tambahan seperti Galeri Gambar, Penampilan Khas (Featured) dan Kombo.",
            "Kami bukan ejen, wakil atau penjamin kepada mana-mana perniagaan yang disenaraikan. Semua urusan, transaksi dan perjanjian antara pengguna dan perniagaan yang disenaraikan adalah tanggungjawab pihak berkenaan sepenuhnya.",
          ],
        },
        {
          heading: "2. Pendaftaran senaraian",
          paragraphs: [
            "Pemilik perniagaan bertanggungjawab memastikan semua maklumat yang dihantar — nama perniagaan, nombor telefon, alamat, lokasi, gambar dan dokumen — adalah benar, terkini dan milik sah anda. Anda memberi kami lisensi tidak eksklusif untuk memapar, menyimpan dan memproses maklumat tersebut bagi tujuan penyenaraian dan promosi platform.",
            "Senaraian hanya akan disiarkan (LIVE) selepas pembayaran diterima atau selepas kupon sah digunakan. Kami berhak menyemak, menyunting, menangguh atau membuang mana-mana senaraian yang didapati palsu, mengelirukan, menyalahi undang-undang atau melanggar terma ini tanpa notis terlebih dahulu.",
          ],
        },
        {
          heading: "3. Bayaran",
          paragraphs: [
            "Bayaran diproses melalui gerbang pembayaran pihak ketiga (toyyibPay / FPX). Harga yang dipaparkan pada halaman Harga adalah dalam Ringgit Malaysia (RM) dan merupakan bayaran satu kali bagi tempoh pakej yang dinyatakan, melainkan dinyatakan sebaliknya. Kami berhak mengubah harga pada bila-bila masa; perubahan tidak menjejaskan pakej yang telah dibayar.",
          ],
        },
        {
          heading: "4. Larangan penggunaan",
          paragraphs: ["Anda tidak dibenarkan:"],
          list: [
            "menghantar maklumat palsu atau menuntut senaraian yang bukan milik anda;",
            "menyiarkan kandungan yang menyalahi undang-undang, lucah, mengancam atau menghina;",
            "mengumpul data (scraping) secara automatik tanpa kebenaran bertulis kami;",
            "mengganggu, menceroboh atau cuba mengakses sistem kami tanpa kebenaran.",
          ],
        },
        {
          heading: "5. Tiada jaminan perkhidmatan",
          paragraphs: [
            "Perkhidmatan disediakan “sebagaimana adanya” (as is). Kami tidak menjamin bahawa penyenaraian akan menghasilkan pertanyaan, jualan, trafik, kedudukan enjin carian atau keuntungan tertentu. Kami juga tidak menjamin perkhidmatan bebas gangguan, ralat atau waktu henti (downtime) yang berpunca daripada penyelenggaraan, pembekal hosting atau faktor di luar kawalan kami.",
          ],
        },
        {
          heading: "6. Had liabiliti",
          paragraphs: [
            "Setakat yang dibenarkan oleh undang-undang, liabiliti kami terhad kepada jumlah yang anda bayar kepada kami dalam tempoh dua belas (12) bulan terakhir. Kami tidak bertanggungjawab terhadap kerugian tidak langsung termasuk kehilangan keuntungan, data atau reputasi.",
          ],
        },
        {
          heading: "7. Penamatan",
          paragraphs: [
            "Kami boleh menamatkan atau menggantung akses anda sekiranya terma ini dilanggar. Anda boleh meminta pembuangan senaraian anda pada bila-bila masa dengan menghubungi kami; bayaran yang telah dibuat tidak dikembalikan kecuali seperti dinyatakan dalam Polisi Pemulangan Wang.",
          ],
        },
        {
          heading: "8. Undang-undang terpakai",
          paragraphs: [
            "Terma ini ditadbir oleh undang-undang Malaysia dan mahkamah Malaysia mempunyai bidang kuasa eksklusif ke atas apa-apa pertikaian yang timbul.",
          ],
        },
        {
          heading: "9. Hubungi kami",
          paragraphs: ["Sebarang pertanyaan berkenaan terma ini boleh dihantar ke info@direktoribiz.my."],
        },
      ],
    },
    en: {
      title: "Terms of Service",
      updated: "June 2026",
      description: "Terms of Service governing the use of the DirektoriBiz.my business directory.",
      intro:
        "These Terms of Service govern your use of the DirektoriBiz.my website and services (the “Service”), operated by YBD INFINITY GLOBAL (202603212324 / JM1048394-W) (“we”, “us”). By accessing this website or registering a business listing, you agree to be bound by the terms below.",
      sections: [
        {
          heading: "1. The service we provide",
          paragraphs: [
            "DirektoriBiz.my is a local business directory platform that publishes business information in Malaysia. We provide listing space, a dedicated business page, and optional promotional packages such as the Photo Gallery, Featured Placement and Combo packages.",
            "We are not an agent, representative or guarantor of any listed business. All dealings, transactions and agreements between users and listed businesses are entirely the responsibility of the parties involved.",
          ],
        },
        {
          heading: "2. Listing registration",
          paragraphs: [
            "Business owners are responsible for ensuring that everything submitted — business name, phone number, address, location, photos and documents — is true, current and lawfully yours. You grant us a non-exclusive licence to display, store and process that information for listing and platform promotion purposes.",
            "A listing goes LIVE only after payment is received or a valid coupon is redeemed. We may review, edit, suspend or remove any listing found to be false, misleading, unlawful or in breach of these terms, without prior notice.",
          ],
        },
        {
          heading: "3. Payments",
          paragraphs: [
            "Payments are processed through a third-party payment gateway (toyyibPay / FPX). Prices shown on the Pricing page are in Malaysian Ringgit (RM) and are one-off payments for the stated package period, unless stated otherwise. We may change prices at any time; changes do not affect packages already paid for.",
          ],
        },
        {
          heading: "4. Prohibited use",
          paragraphs: ["You must not:"],
          list: [
            "submit false information or claim a listing that is not yours;",
            "publish content that is unlawful, obscene, threatening or abusive;",
            "scrape or harvest data automatically without our written permission;",
            "disrupt, intrude on or attempt to access our systems without authorisation.",
          ],
        },
        {
          heading: "5. No service guarantee",
          paragraphs: [
            "The Service is provided “as is”. We do not guarantee that a listing will generate enquiries, sales, traffic, search engine rankings or any particular return. We also do not guarantee uninterrupted, error-free service or freedom from downtime caused by maintenance, hosting providers or factors beyond our control.",
          ],
        },
        {
          heading: "6. Limitation of liability",
          paragraphs: [
            "To the extent permitted by law, our liability is limited to the amount you paid us in the preceding twelve (12) months. We are not liable for indirect losses, including loss of profit, data or reputation.",
          ],
        },
        {
          heading: "7. Termination",
          paragraphs: [
            "We may terminate or suspend your access if these terms are breached. You may request removal of your listing at any time by contacting us; payments already made are not refundable except as stated in our Refund Policy.",
          ],
        },
        {
          heading: "8. Governing law",
          paragraphs: [
            "These terms are governed by the laws of Malaysia, and the Malaysian courts have exclusive jurisdiction over any dispute arising from them.",
          ],
        },
        {
          heading: "9. Contact us",
          paragraphs: ["Any questions about these terms may be sent to info@direktoribiz.my."],
        },
      ],
    },
  },

  privacy: {
    ms: {
      title: "Dasar Privasi",
      updated: "Jun 2026",
      description: "Dasar Privasi DirektoriBiz.my — cara kami mengumpul, menggunakan dan melindungi data anda.",
      intro:
        "Dasar Privasi ini menerangkan bagaimana YBD INFINITY GLOBAL (202603212324 / JM1048394-W), pengendali DirektoriBiz.my, mengumpul, menggunakan, menyimpan dan melindungi maklumat peribadi anda selaras dengan Akta Perlindungan Data Peribadi 2010 (PDPA) Malaysia.",
      sections: [
        {
          heading: "1. Maklumat yang kami kumpul",
          list: [
            "Maklumat penyenaraian: nama perniagaan, kategori, alamat, negeri/daerah, koordinat lokasi, nombor telefon/WhatsApp, emel, pautan media sosial dan gambar.",
            "Dokumen yang dimuat naik: kad perniagaan atau dokumen pendaftaran yang anda muat naik untuk pengesahan atau pengisian automatik butiran.",
            "Maklumat pembayaran: rujukan bil dan status transaksi. Kami TIDAK menyimpan nombor kad kredit atau kelayakan perbankan anda — semua pembayaran diproses oleh gerbang pembayaran pihak ketiga.",
            "Data teknikal: alamat IP, jenis pelayar dan halaman yang dilawati bagi tujuan keselamatan dan statistik asas.",
          ],
        },
        {
          heading: "2. Tujuan penggunaan",
          paragraphs: [
            "Maklumat digunakan untuk menyiarkan senaraian perniagaan anda kepada umum, memproses pembayaran, menghantar resit dan notifikasi transaksi, mengesahkan tuntutan pemilikan senaraian, mencegah penyalahgunaan, serta menambah baik perkhidmatan.",
            "Sila ambil perhatian bahawa maklumat penyenaraian (nama perniagaan, nombor telefon, alamat, lokasi dan gambar) bersifat awam dan boleh dilihat oleh sesiapa serta diindeks oleh enjin carian.",
          ],
        },
        {
          heading: "3. Pendedahan kepada pihak ketiga",
          paragraphs: [
            "Kami tidak menjual data peribadi anda. Data dikongsi hanya dengan pembekal perkhidmatan yang diperlukan untuk menjalankan platform: gerbang pembayaran (toyyibPay), penyedia emel transaksi, penyedia hosting/awan, penyedia peta, dan perkhidmatan pengekstrakan teks automatik (AI) bagi dokumen yang anda muat naik. Kami juga boleh mendedahkan maklumat jika dikehendaki oleh undang-undang atau pihak berkuasa.",
          ],
        },
        {
          heading: "4. Penyimpanan dan keselamatan",
          paragraphs: [
            "Data disimpan selagi senaraian anda aktif atau selagi diperlukan untuk tujuan perakaunan dan undang-undang. Kami mengambil langkah keselamatan teknikal dan organisasi yang wajar termasuk penyulitan semasa penghantaran (HTTPS) dan kawalan akses pentadbir.",
          ],
        },
        {
          heading: "5. Kuki (cookies)",
          paragraphs: [
            "Kami menggunakan storan setempat dan kuki penting untuk mengekalkan sesi log masuk dan keutamaan carian anda. Anda boleh memadam kuki melalui tetapan pelayar, tetapi sebahagian fungsi mungkin terjejas.",
          ],
        },
        {
          heading: "6. Hak anda",
          paragraphs: [
            "Anda berhak meminta akses, pembetulan atau pembuangan maklumat peribadi anda, dan menarik balik persetujuan untuk pemprosesan tertentu. Hantar permintaan ke info@direktoribiz.my dan kami akan bertindak dalam tempoh yang wajar.",
          ],
        },
        {
          heading: "7. Kanak-kanak",
          paragraphs: ["Perkhidmatan ini tidak ditujukan kepada individu di bawah umur 18 tahun."],
        },
        {
          heading: "8. Perubahan dasar",
          paragraphs: [
            "Kami boleh mengemas kini Dasar Privasi ini dari semasa ke semasa. Versi terkini akan sentiasa dipaparkan di halaman ini bersama tarikh kemas kini.",
          ],
        },
      ],
    },
    en: {
      title: "Privacy Policy",
      updated: "June 2026",
      description: "DirektoriBiz.my Privacy Policy — how we collect, use and protect your data.",
      intro:
        "This Privacy Policy explains how YBD INFINITY GLOBAL (202603212324 / JM1048394-W), the operator of DirektoriBiz.my, collects, uses, stores and protects your personal information in line with Malaysia's Personal Data Protection Act 2010 (PDPA).",
      sections: [
        {
          heading: "1. Information we collect",
          list: [
            "Listing information: business name, category, address, state/district, location coordinates, phone/WhatsApp number, email, social media links and photos.",
            "Uploaded documents: business cards or registration documents you upload for verification or automatic form filling.",
            "Payment information: bill references and transaction status. We do NOT store your credit card numbers or banking credentials — all payments are processed by a third-party payment gateway.",
            "Technical data: IP address, browser type and pages visited, for security and basic statistics.",
          ],
        },
        {
          heading: "2. How we use it",
          paragraphs: [
            "Information is used to publish your business listing to the public, process payments, send receipts and transaction notifications, verify listing ownership claims, prevent abuse, and improve the service.",
            "Please note that listing information (business name, phone number, address, location and photos) is public: anyone can see it and search engines may index it.",
          ],
        },
        {
          heading: "3. Disclosure to third parties",
          paragraphs: [
            "We do not sell your personal data. Data is shared only with the service providers needed to run the platform: the payment gateway (toyyibPay), transactional email provider, hosting/cloud provider, map provider, and the automatic (AI) text extraction service for documents you upload. We may also disclose information where required by law or by the authorities.",
          ],
        },
        {
          heading: "4. Retention and security",
          paragraphs: [
            "Data is retained while your listing is active or for as long as required for accounting and legal purposes. We apply reasonable technical and organisational safeguards, including encryption in transit (HTTPS) and administrator access controls.",
          ],
        },
        {
          heading: "5. Cookies",
          paragraphs: [
            "We use local storage and essential cookies to keep your session and search preferences. You may clear cookies in your browser settings, but some features may stop working properly.",
          ],
        },
        {
          heading: "6. Your rights",
          paragraphs: [
            "You may request access to, correction of, or deletion of your personal information, and withdraw consent for certain processing. Send requests to info@direktoribiz.my and we will act within a reasonable time.",
          ],
        },
        {
          heading: "7. Children",
          paragraphs: ["This service is not intended for individuals under 18 years of age."],
        },
        {
          heading: "8. Changes to this policy",
          paragraphs: [
            "We may update this Privacy Policy from time to time. The current version is always shown on this page together with its update date.",
          ],
        },
      ],
    },
  },

  refund: {
    ms: {
      title: "Polisi Pemulangan Wang",
      updated: "Jun 2026",
      description: "Polisi pemulangan wang (refund) bagi senaraian dan pakej promosi DirektoriBiz.my.",
      intro:
        "Polisi ini menerangkan keadaan di mana bayaran kepada DirektoriBiz.my (dikendalikan oleh YBD INFINITY GLOBAL, 202603212324 / JM1048394-W) boleh dipulangkan.",
      sections: [
        {
          heading: "1. Sifat perkhidmatan digital",
          paragraphs: [
            "Semua yuran penyenaraian dan pakej promosi adalah perkhidmatan digital yang diaktifkan serta-merta selepas pembayaran berjaya. Oleh itu, secara amnya bayaran tidak boleh dipulangkan setelah senaraian atau pakej diaktifkan.",
          ],
        },
        {
          heading: "2. Keadaan yang layak pemulangan",
          list: [
            "Bayaran berganda (double charge) untuk senaraian atau pakej yang sama.",
            "Bayaran berjaya ditolak tetapi senaraian atau pakej tidak diaktifkan dan kami tidak dapat membetulkannya dalam tempoh tujuh (7) hari bekerja.",
            "Ralat teknikal pada pihak kami yang menyebabkan perkhidmatan yang dibayar tidak dapat digunakan sama sekali.",
          ],
        },
        {
          heading: "3. Keadaan yang TIDAK layak pemulangan",
          list: [
            "Tukar fikiran selepas senaraian disiarkan.",
            "Senaraian tidak menghasilkan panggilan, pertanyaan, jualan atau trafik seperti yang diharapkan — kami tidak menjamin hasil pemasaran.",
            "Maklumat salah yang dihantar sendiri oleh pemilik perniagaan.",
            "Senaraian dibuang atau digantung kerana melanggar Terma Perkhidmatan (contohnya maklumat palsu atau tuntutan pemilikan tanpa hak).",
            "Pakej promosi yang telah tamat tempoh atau telah digunakan sepenuhnya.",
          ],
        },
        {
          heading: "4. Cara memohon pemulangan",
          paragraphs: [
            "Hantar emel ke info@direktoribiz.my dalam tempoh tujuh (7) hari dari tarikh transaksi, sertakan nama perniagaan, nombor rujukan bil dan penerangan masalah. Kami akan memberi maklum balas dalam tempoh 5 hari bekerja.",
          ],
        },
        {
          heading: "5. Kaedah pemulangan",
          paragraphs: [
            "Pemulangan yang diluluskan akan dikembalikan ke akaun bank atau kaedah pembayaran asal melalui gerbang pembayaran. Tempoh pemprosesan bank biasanya 7–14 hari bekerja. Caj gerbang pembayaran yang tidak boleh dipulihkan mungkin ditolak daripada jumlah pemulangan.",
          ],
        },
      ],
    },
    en: {
      title: "Refund Policy",
      updated: "June 2026",
      description: "Refund policy for DirektoriBiz.my listings and promotional packages.",
      intro:
        "This policy explains when payments made to DirektoriBiz.my (operated by YBD INFINITY GLOBAL, 202603212324 / JM1048394-W) can be refunded.",
      sections: [
        {
          heading: "1. Nature of a digital service",
          paragraphs: [
            "All listing fees and promotional packages are digital services activated immediately after successful payment. As a general rule, payments are therefore non-refundable once the listing or package has been activated.",
          ],
        },
        {
          heading: "2. Situations eligible for a refund",
          list: [
            "Double charge for the same listing or package.",
            "Payment was taken successfully but the listing or package was not activated and we could not fix it within seven (7) working days.",
            "A technical fault on our side that made the paid service completely unusable.",
          ],
        },
        {
          heading: "3. Situations NOT eligible for a refund",
          list: [
            "A change of mind after the listing has gone live.",
            "The listing did not generate the calls, enquiries, sales or traffic you hoped for — we do not guarantee marketing results.",
            "Incorrect information submitted by the business owner.",
            "A listing removed or suspended for breaching the Terms of Service (for example false information or claiming a listing without the right to do so).",
            "Promotional packages that have expired or been fully used.",
          ],
        },
        {
          heading: "4. How to request a refund",
          paragraphs: [
            "Email info@direktoribiz.my within seven (7) days of the transaction date, including your business name, the bill reference number and a description of the problem. We will respond within 5 working days.",
          ],
        },
        {
          heading: "5. Refund method",
          paragraphs: [
            "Approved refunds are returned to the original bank account or payment method through the payment gateway. Bank processing normally takes 7–14 working days. Non-recoverable payment gateway fees may be deducted from the refunded amount.",
          ],
        },
      ],
    },
  },
};
